import { Controller } from "@hotwired/stimulus"

// Publishes the sticky section title height so descendants (the Présentation
// toolbar) can offset their own sticky top and sit just below it.
export default class extends Controller {
  static targets = ["title"]

  connect () {
    this.syncTitleHeight()
    if (typeof ResizeObserver === "undefined" || !this.hasTitleTarget) return

    this.observer = new ResizeObserver(() => this.syncTitleHeight())
    this.observer.observe(this.titleTarget)
  }

  disconnect () {
    this.observer?.disconnect()
  }

  syncTitleHeight () {
    if (!this.hasTitleTarget) return

    this.element.style.setProperty(
      "--form-section-title-height",
      `${this.titleTarget.offsetHeight}px`
    )
  }
}
